import { BillerHomePageRoutingModule } from './biller-home-page-routing.module';
import { NgModule } from '@angular/core';
import { BillerHomePageComponent } from './biller-home-page.component';
import { BillerSharedModule } from '../shared/biller-shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BillerHomePageRoutingModule,
    BillerSharedModule,
    SharedModule,
  ],
  declarations: [BillerHomePageComponent]
})
export class BillerHomePageModule {}
